import { render, staticRenderFns } from "./RemindersPdf.vue?vue&type=template&id=3c2c262c&scoped=true"
import script from "./RemindersPdf.vue?vue&type=script&lang=js"
export * from "./RemindersPdf.vue?vue&type=script&lang=js"
import style0 from "./RemindersPdf.vue?vue&type=style&index=0&id=3c2c262c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c262c",
  null
  
)

export default component.exports